import { Component, Input } from '@angular/core';

@Component({
    selector: 'pa-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['../../../../scss/styles.scss'],
    standalone: false
})
export class SpinnerComponent {
    @Input() loading = false;
}
